<template>
    <div class="mobile-home">
        <HeaderMobile />

        <!-- 轮播图 -->
        <div class="banner-section" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd">
            <div class="banner-wrapper" :style="{ transform: `translateX(${translateX}px)`, transition: touching ? 'none' : 'transform 0.3s' }">
                <div class="banner-item" v-for="(item, index) in bannerList" :key="item.id" @click="handleBannerClick(item)">
                    <img :src="getImageUrl(item.img)" @error="handleImgError($event)" draggable="false" />
                </div>
            </div>
            <div class="banner-indicators" v-if="bannerList.length > 1">
                <span v-for="(item, index) in bannerList" :key="index" :class="{ active: index === currentIndex }"></span>
            </div>
        </div>

        <!-- 分类导航 -->
        <div class="category-section">
            <div class="category-scroll">
                <div class="category-item" v-for="item in categoryList" :key="item.id" @click="handleGoCategory(item.id)">
                    <div class="category-icon">
                        <i class="el-icon-folder-opened"></i>
                    </div>
                    <div class="category-name">{{ item.name }}</div>
                </div>
            </div>
        </div>

        <!-- 最新推荐 -->
        <div class="section newest-section">
            <div class="section-header">
                <i class="el-icon-date"></i>
                <span>最新推荐</span>
            </div>
            <div class="course-list">
                <div class="course-card" v-for="course in newestCourses" :key="course.id" @click="goCourseDetail(course.id)">
                    <img :src="getImageUrl(course.cover)" @error="handleImgError($event)" />
                    <div class="course-info">
                        <div class="course-title">{{ course.name }}</div>
                        <div class="course-meta">
                            <span><i class="el-icon-user"></i>{{ course.author_name }}</span>
                            <span><i class="el-icon-view"></i>{{ course.student_count || 0 }}人</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 最热推荐 -->
        <div class="section hottest-section">
            <div class="section-header">
                <i class="el-icon-fire"></i>
                <span>最热推荐</span>
            </div>
            <div class="course-list">
                <div class="course-card" v-for="course in hottestCourses" :key="course.id" @click="goCourseDetail(course.id)">
                    <img :src="getImageUrl(course.cover)" @error="handleImgError($event)" />
                    <div class="course-info">
                        <div class="course-title">{{ course.name }}</div>
                        <div class="course-meta">
                            <span><i class="el-icon-user"></i>{{ course.author_name }}</span>
                            <span><i class="el-icon-play"></i>{{ course.looks || 0 }}次</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <FooterMobile />

        <!-- 回到顶部 -->
        <div class="back-top" v-show="showBackTop" @click="scrollToTop">
            <i class="el-icon-arrow-up"></i>
        </div>
    </div>
</template>

<script>
import HeaderMobile from '@/components/mobile/header.vue';
import FooterMobile from '@/components/mobile/fotter.vue';
import { getCategory, getCarousel, getHome } from '@/api/home';

export default {
    name: 'MobileIndex',
    components: {
        HeaderMobile,
        FooterMobile
    },
    data() {
        return {
            categoryList: [],
            bannerList: [],
            newestCourses: [],
            hottestCourses: [],
            popularCourses: [],
            popularAuthors: [],
            currentIndex: 0,
            startX: 0,
            moveX: 0,
            translateX: 0,
            touching: false,
            autoplayTimer: null,
            showBackTop: false
        };
    },
    created() {
        this.fetchData();
    },
    mounted() {
        this.startAutoplay();
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        this.stopAutoplay();
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        fetchData() {
            Promise.all([
                getCategory(),
                getCarousel(),
                getHome()
            ]).then(([categoryRes, carouselRes, homeRes]) => {
                this.categoryList = categoryRes.data || [];
                this.bannerList = carouselRes.data || [];
                this.newestCourses = homeRes.data.newest || [];
                this.hottestCourses = homeRes.data.hot_view || [];
                this.popularCourses = homeRes.data.hot_collect || [];
                this.popularAuthors = homeRes.data.hot_author || [];
            }).catch(error => {
                console.error('获取首页数据失败:', error);
            });
        },
        handleBannerClick(banner) {
            if (!banner.type || banner.type === 0) return;
            if (banner.type === 1) {
                this.$router.push(`/mobile/category/${banner.cid}`);
            } else if (banner.type === 2) {
                this.$router.push(`/mobile/course/${banner.course_id}`);
            } else if (banner.type === 3) {
                window.location.href = banner.url;
            }
        },
        getImageUrl(url) {
            if (!url) return require('@/static/imgs/default.jpeg');
            if (typeof url === 'string' && (url.startsWith('http://') || url.startsWith('https://'))) return url;
            return process.env.VUE_APP_STATIC_URL + url;
        },
        handleGoCategory(id) {
            this.$router.push(`/mobile/category/${id}`);
        },
        goCourseDetail(id) {
            this.$router.push(`/mobile/course/${id}`);
        },
        goAuthorDetail(author) {
            this.$router.push('/mobile/search?keyword=' + author.name + '&type=teacher');
        },
        handleImgError(event) {
            event.target.src = require('@/static/imgs/default.jpeg');
        },
        handleTouchStart(e) {
            if (this.bannerList.length <= 1) return;
            this.touching = true;
            this.startX = e.touches[0].clientX;
            this.stopAutoplay();
        },
        handleTouchMove(e) {
            if (this.bannerList.length <= 1 || !this.touching) return;
            this.moveX = e.touches[0].clientX - this.startX;
            this.translateX = -this.currentIndex * window.innerWidth + this.moveX;
        },
        handleTouchEnd() {
            if (this.bannerList.length <= 1 || !this.touching) return;
            this.touching = false;
            if (Math.abs(this.moveX) > 50) {
                if (this.moveX > 0 && this.currentIndex > 0) {
                    this.currentIndex--;
                } else if (this.moveX < 0 && this.currentIndex < this.bannerList.length - 1) {
                    this.currentIndex++;
                }
            }
            this.translateX = -this.currentIndex * window.innerWidth;
            this.moveX = 0;
            this.startAutoplay();
        },
        startAutoplay() {
            if (this.bannerList.length <= 1) return;
            this.stopAutoplay();
            this.autoplayTimer = setInterval(() => {
                this.currentIndex = (this.currentIndex + 1) % this.bannerList.length;
                this.translateX = -this.currentIndex * window.innerWidth;
            }, 3000);
        },
        stopAutoplay() {
            if (this.autoplayTimer) {
                clearInterval(this.autoplayTimer);
                this.autoplayTimer = null;
            }
        },
        handleScroll() {
            this.showBackTop = window.scrollY > 300;
        },
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }
};
</script>

<style scoped>
.mobile-home {
    min-height: 100vh;
    background: #f5f5f5;
    padding-top: 60px;
}

/* 轮播图 */
.banner-section {
    background: #fff;
    position: relative;
    overflow: hidden;
    height: 180px;
}
.banner-wrapper {
    display: flex;
    height: 100%;
}
.banner-item {
    flex-shrink: 0;
    width: 100vw;
    height: 180px;
}
.banner-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    user-select: none;
    -webkit-user-drag: none;
}
.banner-indicators {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 6px;
}
.banner-indicators span {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.5);
    transition: all 0.3s;
}
.banner-indicators span.active {
    width: 16px;
    border-radius: 3px;
    background: #fff;
}

/* 分类导航 */
.category-section {
    background: #fff;
    padding: 15px 0;
    margin-bottom: 10px;
    overflow: hidden;
}
.category-scroll {
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 0 15px;
    gap: 20px;
    scrollbar-width: none;
    -ms-overflow-style: none;
}
.category-scroll::-webkit-scrollbar {
    display: none;
}
.category-item {
    flex-shrink: 0;
    text-align: center;
    width: 60px;
}
.category-icon {
    width: 50px;
    height: 50px;
    margin: 0 auto 8px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.category-icon i {
    font-size: 24px;
    color: #fff;
}
.category-name {
    font-size: 12px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* 通用区块 */
.section {
    background: #fff;
    margin-bottom: 10px;
    padding: 15px;
}
.section-header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    font-size: 16px;
    font-weight: 600;
    color: #333;
}
.section-header i {
    font-size: 18px;
    margin-right: 8px;
}
.newest-section .section-header i {
    color: #1890ff;
}
.hottest-section .section-header i {
    color: #f56c6c;
}


/* 课程列表 */
.course-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
}
.course-card {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}
.course-card img {
    width: 100%;
    height: 100px;
    object-fit: cover;
}
.course-info {
    padding: 10px;
}
.course-title {
    font-size: 14px;
    color: #333;
    margin-bottom: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    min-height: 40px;
}
.course-meta {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #999;
}
.course-meta i {
    font-size: 12px;
    margin-right: 4px;
}

/* 回到顶部 */
.back-top {
    position: fixed;
    right: 16px;
    bottom: 60px;
    width: 40px;
    height: 40px;
    background: rgba(0,0,0,0.5);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
}
.back-top i {
    color: #fff;
    font-size: 20px;
}
.back-top:active {
    background: rgba(0,0,0,0.7);
}


</style>
